/**
 * This script will allow for the following:
 * - desktop navigation can hover over drop down items
 * - desktop top level items (with drop downs) click through to their respective pages
 * - mobile (under BREAKPOINT) can toggle drop down items
 * - mobile can still click through to sub-pages but cannot click through to top level pages with drop downs
 *
 * Overall was inspired by various sources online and then customized to our needs, particularly around
 * the mobile behaviour
 *
 * @author Dan Klassen <dan@triplei.ca>
 */
document.addEventListener("DOMContentLoaded", function () {
    const BREAKPOINT = 1200;

    // Bootstrap makes top level drop down items not clickable - we want to override that
    document.querySelectorAll('.navbar .nav-item a.nav-link').forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            window.location = this.href;
        });
    });

    // add a class to the navigation when the offcanvas toggled on / off
    document.querySelectorAll('.navbar-collapse.offcanvas').forEach(function(item) {
        item.addEventListener('show.bs.offcanvas', function () {
            item.closest('.ccm-block-top-navigation-bar').classList.add('offcanvas-open');
        });
        item.addEventListener('hidden.bs.offcanvas', function () {
            item.closest('.ccm-block-top-navigation-bar').classList.remove('offcanvas-open');
        });
    })

    if (window.innerWidth > BREAKPOINT) {
        document.querySelectorAll('.navbar .nav-item').forEach(function (item) {
            // bootstrap 5 makes drop down items only show on click - we want them to show / hide on hover
            item.addEventListener('mouseover', function (e) {
                let linkElm = this.querySelector('a[data-bs-toggle]');

                if (linkElm !== null) {
                    let dropdown = linkElm.parentElement.querySelector('.dropdown-menu');
                    linkElm.classList.add('show');
                    dropdown.classList.add('show');
                }
            });
            item.addEventListener('mouseleave', function (e) {
                let linkElm = this.querySelector('a[data-bs-toggle]');

                if (linkElm !== null) {
                    let dropdown = linkElm.parentElement.querySelector('.dropdown-menu');
                    linkElm.classList.remove('show');
                    dropdown.classList.remove('show');
                }
            });
        });

    } else {
        document.querySelectorAll('.navbar .nav-item .dropdown-arrow').forEach(function (item) {
            // we want to make the drop arrows toggle the sub-navigation on touch on small screens
            item.addEventListener('click', function (e) {
                e.preventDefault();
                let arrow = this;
                let dropdown = arrow.parentNode.querySelector('.dropdown-menu');

                if (dropdown.classList.contains('show')) {
                    dropdown.classList.remove('show');
                } else {
                    dropdown.classList.add('show');
                }
            });
        });
    }

    // Enable transparency
    const transparentNavbar = document.querySelector('div[data-transparency=navbar]');
    const toolbar = document.querySelector('#ccm-toolbar');
    if (transparentNavbar) {
        const navbar = transparentNavbar.querySelector('.navbar');
        // Check the next item to see if it supports transparency

        if (navbar && navbar.classList.contains('fixed-top') && toolbar) {
            navbar.classList.remove('fixed-top');
        }

        const nextElement = transparentNavbar.nextElementSibling;
        if (nextElement && nextElement.matches('[data-transparency=element]') && !toolbar) {
            transparentNavbar.classList.add('transparency-enabled');

            if (navbar && navbar.classList.contains('fixed-top')) {
                window.addEventListener('scroll', function () {
                    const isScrolled = window.scrollY > 5;
                    if (isScrolled) {
                        transparentNavbar.classList.remove('transparency-enabled');
                    } else {
                        transparentNavbar.classList.add('transparency-enabled');
                    }
                });
            }
        }
        transparentNavbar.style.display = 'block';

        // In phone mode, we need to hook into the expand/collapse event to remove transparency, because
        // we don't want to have transparency when the menu is expanded in phone mode.
        const toggler = transparentNavbar.querySelector('[data-bs-toggle]');
        if (toggler) {
            const targetSelector = toggler.getAttribute('data-bs-target');
            const target = document.querySelector(targetSelector);
            if (target) {
                target.addEventListener('show.bs.collapse', function () {
                    transparentNavbar.classList.add('transparency-temporarily-disabled');
                });
                target.addEventListener('hidden.bs.collapse', function () {
                    transparentNavbar.classList.remove('transparency-temporarily-disabled');
                });
            }
        }
    }
});